"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = exports.isFalse = exports.isTrue = exports.isNothing = exports.not = exports.is = void 0;

var _curry = require("../curry/curry");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Test if something is not `null` or `undefined`
 *
 * @tag Core
 * @signature is(source): boolean
 *
 * @param {any} source Source variable
 *
 * @return {boolean}
 *
 * @example
 *
 * is(null)      // => false
 * is(0)         // => true
 * is(undefined) // => false
 * is("")        // => true
 * is(false)     // => true
 * is(NaN)       // => false
 */
var is = function is(source) {
  return source !== null && source !== undefined && !Number.isNaN(source);
};

exports.is = is;

var isNothing = function isNothing(source) {
  return source === null || source === undefined || Number.isNaN(source);
};

exports.isNothing = isNothing;

var isObject = function isObject(source) {
  return source !== null && _typeof(source) === "object" && !Array.isArray(source);
};

exports.isObject = isObject;

var isTrue = function isTrue(source) {
  return source === true;
};

exports.isTrue = isTrue;

var isFalse = function isFalse(source) {
  return source === false;
};

exports.isFalse = isFalse;
var not = (0, _curry.curry)(function (fn, source) {
  return !fn(source);
});
exports.not = not;